module.exports = __webpack_public_path__ + "img/step4.ce83c0df.png";